import { API_URL } from '../../constants';
import Button, { ButtonStyle } from '../Button/Button';
import styles from './Product.module.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadsIcon, PulseRingsIcon } from '../Icon/Icon';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useDownloadFile from '../../hooks/useDownloadFile';

const DownloadPDFButton = ({
    slug,
    filename,
    extraClasses,
    isIconOnly = false,
    disabled = false,
}) => {
    const { t } = useTranslation();
    const { downloadFile, isLoading } = useDownloadFile(
        API_URL,
        'product/pdf/:id',
        'application/pdf',
        true
    );
    const isButtonDisabled = isLoading || disabled;
    const handleDownload = async (e) => {
        e.stopPropagation();
        await downloadFile(slug, filename);
    };

    return isIconOnly ? (
        isLoading ? (
            <PulseRingsIcon className={classNames(extraClasses, styles.PulseRingsIcon)} />
        ) : (
            <DownloadsIcon
                className={extraClasses}
                onClick={isButtonDisabled ? undefined : handleDownload}
                style={{
                    pointerEvents: isButtonDisabled ? 'none' : 'auto',
                    opacity: isButtonDisabled ? 0.5 : 1,
                }}
            />
        )
    ) : (
        <Button
            text={isLoading ? t('products.pdfBeingGenerated') : t('products.downloadAsPDF')}
            style={ButtonStyle.PRIMARY}
            icon={isLoading ? 'pulse-rings' : 'downloads'}
            onClick={handleDownload}
            disabled={isButtonDisabled}
            extraClasses={classNames(styles.ProductDownloadPdfButton, extraClasses)}
        />
    );
};

DownloadPDFButton.propTypes = {
    slug: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
    isIconOnly: PropTypes.bool,
    extraClasses: PropTypes.string,
    disabled: PropTypes.bool,
};

export default DownloadPDFButton;
